/* eslint-disable import/no-cycle */
import baseApi from '@features/base/BaseSlice';
import {
  ScheduleApiProps,
} from './types';
import schedule from './schedule';

const ScheduleTag = baseApi.enhanceEndpoints({ addTagTypes: [schedule.tagType] });
const scheduleApi = ScheduleTag.injectEndpoints({
  endpoints: (builder) => ({
    getSchedule: builder.query<ScheduleApiProps, number>(schedule.getEntity()),
    addSchedule: builder.mutation<ScheduleApiProps, Partial<ScheduleApiProps>>(
      schedule.addEntity('site-reports'),
    ),
    updateSchedule: builder.mutation<void, Pick<ScheduleApiProps, 'id'> & Partial<ScheduleApiProps>>(schedule.updateEntity()),
    deleteSchedule: builder.mutation<{ success: boolean; id: number }, number>(
      schedule.deleteEntity(),
    ),
    getSiteSchedules: builder.query<ScheduleApiProps[], number>(schedule.getSiteSchedules()),
    downloadSiteReport: builder.query<
      { blob: Blob; filename: string },
      number
    >(
      schedule.downloadSiteReport(),
    ),

  }),
  overrideExisting: false,
});

export const {
  useAddScheduleMutation,
  useGetScheduleQuery,
  useUpdateScheduleMutation,
  useDeleteScheduleMutation,
  useGetSiteSchedulesQuery,
  useLazyDownloadSiteReportQuery,
} = scheduleApi;
